import axios from 'axios';

import cfac22 from '../cfac22';

export default function deleteInbox(uId, id) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      delete(`${cfac22('API_HOST_V2')}/inbox/delete`, {
        headers: {

          'Full-Url': window.location.href
        },
        data: { id }, withCredentials: true
      }).
      then((result) => {
        // console.log("RESULT_DELETE_MESSAGE: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_DELETE_MESSAGE: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
